import React from 'react';
import './RoleDisplay.scss';
import { User } from '../../models/User';
import { Avatar } from '../avatar/Avatar';
import { DossierV2 } from '../../models/DossierV2';
import { DossierMember } from '../../models/DossierMember';

interface RoleDisplayProps {
  dossier?: DossierV2;
  dossierRelation?: DossierMember;
  user?: User;
  className?: string;
}

export default function RoleDisplay({ dossier, dossierRelation, user, className }: RoleDisplayProps): JSX.Element {
  const fullClassName = `role-display ${className ? className : ''}`;

  let name = '';
  let roleText = <></>;
  if (dossier) {
    // eslint-disable-next-line prefer-destructuring
    name = dossier.name;
    roleText = <>Jouw rol is {dossierRelation?.getRoleText()}</>;
  } else if (user) {
    // eslint-disable-next-line prefer-destructuring
    name = user.name;
    roleText = <>Jij bent {user.getRoleText()}</>;
  }

  return (
    <div className={fullClassName}>
      <Avatar className="role-display__avatar" user={user} />
      <div className="role-display__container">
        <div className="role-display__name">{name}</div>
        <div className="role-display__role">{roleText}</div>
      </div>
    </div>
  );
}
